export const otp = {
    title:"Подтверждение безопасности",
    label:"Код подтверждения электронной почты",
    content:"Введите 6-значный код, отправленный на",
    button:"Подтвердить",
    backToLogin: "Вернуться к входу",
    receivedCode: "Вы не получили код? Запросите новый через ",
    seconds: "{seconds} секунд",
    receivedCodeYet:"Вы не получили код?",
    resendCode: "Отправить код еще раз"
};
